export default __webpack_public_path__ + "static/media/product-4.ed481e7a.jpg";